var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"echarts"},[_c('div',{staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"lineEchart"}})])}]

export { render, staticRenderFns }